import { render, staticRenderFns } from "./NewOrderNotifyRule.vue?vue&type=template&id=7852467c&scoped=true"
import script from "./NewOrderNotifyRule.vue?vue&type=script&lang=js"
export * from "./NewOrderNotifyRule.vue?vue&type=script&lang=js"
import style0 from "./NewOrderNotifyRule.vue?vue&type=style&index=0&id=7852467c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7852467c",
  null
  
)

export default component.exports